export default __webpack_public_path__ + "static/media/andes_a_la_selva_3.c91c21f2.JPG";